<template>
    <div>
        <az-sub-title title="Fixar Executante">
            <a class="card-link" href="#" @click.prevent="incluir_filtro()" v-if="!viewonly">
                <i class="fas fa-plus mr-2"></i>
                Incluir Regra
            </a>
        </az-sub-title>
        <div class="mt-2">
            <div class="form-row" v-for="(filtro, ifx) in lista_filtros" :key="ifx">
                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        type="select"
                        optionsMode="json"
                        :optionsList="opcoes"
                        optionsData="id"
                        :validate="validate"
                        required
                        :edicao="!viewonly"
                        v-model="filtro.model_type">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend" v-if="!viewonly">
                                <button class="btn btn-outline-danger" type="button" @click="remover_item(ifx)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>                                
                </div>
                <div class="col col-12 col-md-5">
                    <input type="text" placeholder="..." class="form form-control form-control-sm" disabled v-if="!filtro.model_type">
                    <az-input
                        sizing="sm"
                        v-else-if="serviceFiltro(filtro.model_type)"
                        placeholder
                        type="autocomplete" 
                        optionsMode="aql"
                        :optionsSync="!infoFiltro(filtro.model_type).nosync"
                        :service="serviceFiltro(filtro.model_type)" 
                        :optionsName="'filtro-' + filtro.model_type + infoFiltro(filtro.model_type).name"
                        :optionsParm="{ ativos: true, agenda: true, ...infoFiltro(filtro.model_type).parms }"
                        :optionsData="infoFiltro(filtro.model_type).model_id"
                        required 
                        :edicao="!viewonly"
                        v-model="filtro.model_id" />
                </div>
                <div class="col col-12 col-md-4">
                    <az-input
                        sizing="sm"
                        placeholder="Selecione o Profissional"
                        type="autocomplete" 
                        optionsMode="aql"
                        service="medicos.index" 
                        :optionsParm="{ ativos: true, agenda: true }"
                        optionsData="id_pessoa"
                        required 
                        :edicao="!viewonly"
                        v-model="filtro.id_medico" />
                </div>
            </div>
        </div>

        <div class="row mb-2" v-if="!lista_filtros.length">
            <div class="col col-12">
                <span class="text-muted">
                    Nenhuma regra definida
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubTitle from '../../../util/AzSubTitle.vue';

export default {
    data() { 
        return { 
            filtros: null, 
        }
    },

    components: { 
        AzInput,
        AzSubTitle,
    },

    props: ['value', 'validate', 'opcoes', 'viewonly', 'title'],

    computed: { 
        lista_filtros: function () { 

            if ( !this.filtros ) 
                return [];

            return this.filtros.filter(item => !item.excluido);
        },
    },

    watch: { 
        filtros: {
            handler: function (newValue) { 
                this.$emit('input', newValue);
            },
            immediate: true,
            deep: true, 
        },

        value: {
            handler: function (newValue) {
                this.filtros = newValue;
            },
            immediate: true,
        },
    },

    methods: { 
        remover_item (idx) { 
            this.value.splice(idx, 1);
        },

        infoFiltro(model) { 
            if ( !this.opcoes || !model ) 
                return null;

            let opcao = this.opcoes.find(item => item.id == model);

            return opcao;
        },

        serviceFiltro(model) { 
            let opcao = this.infoFiltro(model);
            return opcao ? opcao.service : null;
        },

        incluir_filtro() { 
            if ( !this.value ) { 
                this.value = [];
            }

            this.value.push({ 
                model_type: "",
                model_id: "",
                id_medico: "", 
            });
        },
    },
}
</script>